"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardContent = void 0;

var _stylitas = require("@creditas/stylitas");

var _cardContent = require("./cardContent.style");

const CardContent = _stylitas.styled.div`
  ${_cardContent.cardContentBase};
`;
exports.CardContent = CardContent;